import {
  BillingRuleConditionParameter,
  BillingRuleConditionParameterType,
  BillingRuleConditionTarget,
  FuelCostPeriod,
} from "../../graphql/generated";

export const conditionParametersPerTarget: Partial<
  Record<BillingRuleConditionTarget, BillingRuleConditionParameterType[]>
> = {
  [BillingRuleConditionTarget.FuelCost]: [
    BillingRuleConditionParameterType.FuelCostArea,
    BillingRuleConditionParameterType.FuelCostPeriod,
    BillingRuleConditionParameterType.FuelCostEffectiveDay,
    BillingRuleConditionParameterType.FuelCostBasis,
  ],
};

// Built from the target, so rules saved before a parameter existed show it.
export const buildConditionParameters = (
  target: BillingRuleConditionTarget,
  stored?: BillingRuleConditionParameter[] | null
): BillingRuleConditionParameter[] =>
  (conditionParametersPerTarget[target] || []).map((type) => ({
    type,
    value: stored?.find((parameter) => parameter.type === type)?.value ?? null,
  }));

// A monthly rate reads one figure per month, so there is no day for it to
// start on.
export const isParameterHidden = (
  type: BillingRuleConditionParameterType,
  parameters: BillingRuleConditionParameter[]
) =>
  type === BillingRuleConditionParameterType.FuelCostEffectiveDay &&
  parameters.find(
    (parameter) =>
      parameter.type === BillingRuleConditionParameterType.FuelCostPeriod
  )?.value === FuelCostPeriod.Monthly;

export const visibleConditionParameters = (
  parameters: BillingRuleConditionParameter[]
) =>
  parameters.filter(
    (parameter) => !isParameterHidden(parameter.type, parameters)
  );
